import React__default from 'react';
import styled from 'styled-components';

const Image = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-storm-ui-40027066__sc-yxrhat-0"
})(["&&{max-width:100%;max-height:100%;}"]);
const DefaultImage = ({
  url,
  alt = ''
}) => /*#__PURE__*/React__default.createElement(Image, {
  src: url,
  alt: alt
});

export { DefaultImage as D };
//# sourceMappingURL=DefaultImage-2nEwKHwk.js.map
